import { Component, OnInit } from '@angular/core';
import { SistRadnihMesta } from './sist-radnih-mesta';
import { BaseUpdateComponent, BaseDataService, ModalService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sist-radnih-mesta-stavka-update',
  templateUrl: './sist-radnih-mesta-stavka-update.component.html'
})
export class SistRadnihMestaStavkaUpdateComponent
extends BaseUpdateComponent<SistRadnihMesta>
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);

   }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('RadnoMestoID', Validators.required, 'required', 'SISTRADNIHMESTA.RADNOMESTO.VALIDATION.REQUIRED');
    // this.addValidatorToFc('OrgJedID', Validators.required, 'required', 'SISTRADNIHMESTA.ORGJED.VALIDATION.REQUIRED');
    this.addValidatorToFc('broj_izvrsilaca', Validators.required, 'required', 'SISTRADNIHMESTA.BROJIZVRSILACA.VALIDATION.REQUIRED');

    // this.IDProcessed
    // .subscribe((value) => {
    //     if (value && this.Item.ID == -1) {
    //       this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
    //       this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
    //     }
    //   })
  }

  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}

}
